<template>
  <div class="cr cr-bottom cr-left cr-orange" v-if="environmentText">
    <span v-tooltip="`ระบบสำหรับทดสอบโปรแกรมเท่านั้น`">{{
      environmentText
    }}</span>
  </div>
  <div class="layout-menu-container">
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
    />
  </div>
</template>

<script lang="ts">
import AppSubmenu from "./AppSubmenu.vue";
import { computed, defineComponent } from "vue";
export default defineComponent({
  name: "AppMenu",
  components: {
    AppSubmenu: AppSubmenu,
  },
  emits: ["menuitem-click"],
  props: {
    model: Array,
  },
  setup(props, { emit }) {
    const onMenuItemClick = (event: any) => {
      emit("menuitem-click", event);
    };
    const environmentText = computed(() => {
      var origin = window.origin.toLowerCase();
      return origin.indexOf("localhost") >= 0 || origin.indexOf("ngrok") >= 0
        ? "Local"
        : origin.indexOf("dev") >= 0
        ? "DEV"
        : origin.indexOf("qas") >= 0
        ? "QAS"
        : null;
    });

    return {
      onMenuItemClick,
      environmentText,
    };
  },
});
</script>

<style></style>
